import { createSelector } from '@ngrx/store'
import * as R from 'ramda'
import { selectInquiryEntities } from '@tv3/store/inquiry/inquiry.selectors'
import { createdBySystemNameMappings, selectUsers, User } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'
import { userFullname } from '@tokeet-frontend/tv3-platform'
import { selectAutomationEntities } from '@tokeet-frontend/automations'
import {
  selectTasksWithoutDrafts,
  selectUnarchivedTasks,
  TaskResponse,
  taskToView,
  TaskView,
} from '@tokeet-frontend/tasks'
import { selectAllVendors } from '@tokeet-frontend/vendors'
import { selectIncidentEntities } from '@tokeet-frontend/incident'

export const selectAllTasksViews = (includeArchived = false) =>
  createSelector(
    includeArchived ? selectTasksWithoutDrafts : selectUnarchivedTasks,
    selectAvailableTaskAssignees,
    selectInquiryEntities,
    selectAutomationEntities,
    selectIncidentEntities,
    (tasks, assignees, inquiryEntities, triggersById, incidentsById) => {
      const assigneesById = lodash.keyBy(assignees, 'id')
      return R.map((t: TaskResponse) => {
        const view: TaskView = taskToView(t)
        const trigger = triggersById[t.trigger_id]
        const createdBy = assigneesById[t.created_by]
        const incident = incidentsById[t.incident_id]

        view.incidentView = incident?.title
        view.createdByView =
          trigger?.attributes?.name ||
          createdBySystemNameMappings[t.created_by] ||
          (createdBy ? createdBy.name : t.created_by)
        view.inquiryView = R.pathOr('', ['guestDetails', 'name'], inquiryEntities[view.inquiry_id])
        const assignees = lodash.compact(lodash.map(view.user_ids, (id) => assigneesById[id]))
        view.usersView = assignees.map((t) => t.name).join(', ')
        view.user_ids = assignees.map((t) => t.id) // cleat not existing users
        return view
      }, tasks)
    }
  )

export const selectBookingTaskViews = (bookingId: string) =>
  createSelector(selectAllTasksViews(), (items) => {
    return items?.filter((t) => t.inquiry_id === bookingId)
  })

export const selectIncidentTaskViews = (incidentId: string) =>
  createSelector(selectAllTasksViews(), (items) => {
    return items?.filter((t) => t.incident_id === incidentId)
  })

export const selectTaskViewById = (id: string) =>
  createSelector(selectAllTasksViews(), (items) => {
    return items.find((t) => t.pkey === id)
  })

export type TaskAssignee = {
  id: string
  name: string
  type: string
}
export const selectAvailableTaskAssignees = createSelector(selectUsers, selectAllVendors, (users, vendors) => {
  const items: TaskAssignee[] = [
    ...users.map((u) => ({ id: u.id, name: userFullname(u), type: $localize`User` })),
    ...vendors.map((v) => ({ id: v.pkey, name: v.name, type: $localize`Vendor` })),
  ]
  return lodash.sortBy(items, 'name')
})
